import { Pipe, PipeTransform } from '@angular/core';

import { SummaryConfigType } from '@shared/constants/summary.const';

@Pipe({
  name: 'sortColumnName',
  standalone: true,
})
export class SortColumnNamePipe implements PipeTransform {
  transform(columnKey: string, config?: SummaryConfigType, reportView?: number): string {
    if (config?.queries && reportView) {
      const query = config.queries.find(q => q.queryId === reportView);
      if (query?.columns?.[columnKey]?.displayKey) {
        return query.columns[columnKey].displayKey;
      }
    }

    switch (columnKey) {
      case 'unit.name':
        return 'Unit';
      case 'unit.propertyName':
        return 'Property';
      case 'inspectionType':
        return 'Inspection';
      case 'dueDate':
        return 'Due Date';
      case 'status':
        return 'Status';
      case 'expiredAt':
        return 'Expiration';
      case 'completedAt':
        return 'Done';
      default:
        return this.deCamelCase(columnKey);
    }
  }

  private deCamelCase(str: string): string {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
